module.exports = __webpack_public_path__ + "assets/onGoingTrip.3704dfc4.svg";